import {createSelector} from 'reselect';

const getUI = state => state.ui;

export default createSelector(
  [getUI],
  ui => ui.checkoutProgressStep === ui.sections.length,
);
